<template>
    <div>
        <collapsible-block
            v-if="!businessOrder.pallets.length"
            ref="collapsible"
            class="handling-units"
            :title-text="$t('businessOrders.labels.handlingUnits')"
            :disabled="!isVisible"
            :collapsed="!isVisible"
        >
            <template v-if="isVisible">
                <div v-for="(handlingUnit, index) in packagesWithDimensions"
                     :key="index"
                     class="flex--no-wrap"
                >
                    <h3 class="handling-units__heading-subsection">
                        {{ $t('businessOrders.labels.handlingUnit.name', {no: index + 1}) }}
                    </h3>
                    <flex-row
                        column-spacing="lg"
                        class="flex--no-wrap"
                    >
                        <div class="col handling-units__measurements">
                            <value-wrapper :label="$t('businessOrders.labels.handlingUnit.weight')">
                                {{ `${handlingUnit.weight} lbs.` }}
                            </value-wrapper>
                        </div>
                        <div class="col handling-units__measurements">
                            <div class="handling-units__vertical-separator" />
                        </div>
                        <div class="col handling-units__measurements">
                            <value-wrapper :label="$t('businessOrders.labels.handlingUnit.length')">
                                {{ `${handlingUnit.length} in.` }}
                            </value-wrapper>
                        </div>
                        <div class="col handling-units__measurements">
                            <value-wrapper :label="$t('businessOrders.labels.handlingUnit.width')">
                                {{ `${handlingUnit.width} in.` }}
                            </value-wrapper>
                        </div>
                        <div class="col handling-units__measurements">
                            <value-wrapper :label="$t('businessOrders.labels.handlingUnit.height')">
                                {{ `${handlingUnit.height} in.` }}
                            </value-wrapper>
                        </div>
                        <div class="col handling-units__measurements">
                            <value-wrapper :label="$t('businessOrders.labels.trackingNumber')">
                                {{ handlingUnit.trackingNumber }}
                            </value-wrapper>
                        </div>
                    </flex-row>
                    <div class="handling-units__sku-table stick-to-modal-sides">
                        <order-package-items
                            :package-items="handlingUnit.items"
                            stick-to-sides
                            :business-order="businessOrder"
                            :sku-prefix="index.toString()"
                        />
                    </div>
                </div>
            </template>
        </collapsible-block>
        <template v-if="isVisible && businessOrder.pallets.length > 0">
            <div v-for="(pallet, index) in palletsWithDimensions"
                 :key="index"
                 class="flex--no-wrap"
            >
                <collapsible-block
                    class="pallet-unit"
                    :title-text="$t('businessOrders.labels.pallet.name', {no: index + 1})"
                    :collapsed="false"
                >
                    <div class="v-spacing-sm">
                        <flex-row column-spacing="lg"
                                  class="flex--no-wrap"
                        >
                            <div class="col col--wrap-text">
                                <value-wrapper :label="$t('businessOrders.labels.trackingNumber')">
                                    {{ pallet.tracking | valueOrDash }}
                                </value-wrapper>
                            </div>
                            <div class="col col--wrap-text">
                                <value-wrapper :label="$t('businessOrders.labels.pallet.dimensions')">
                                    {{ pallet.dimensions | valueOrDash }}
                                </value-wrapper>
                            </div>
                            <div class="col">
                                <value-wrapper :label="$t('businessOrders.labels.pallet.ratedWeight')">
                                    {{ pallet.weight | valueOrDash }}
                                </value-wrapper>
                            </div>
                        </flex-row>
                    </div>
                    <h2 v-if="pallet.packages
                            && pallet.packages.some(x => x.palletizationType == 1 || x.palletizationType == null && x.dimensions != zeroDims)"
                        class="heading-with-separator pallet-section-header"
                    >
                        <span class="heading-with-separator__inner">
                            {{ $t('businessOrders.labels.pallet.cartons') }}
                        </span>
                    </h2>
                    <div v-for="(palletPackage, skuIndex) in
                             pallet.packages.filter(x => x.palletizationType == 1 || x.palletizationType == null && x.dimensions != zeroDims)"
                         :key="skuIndex"
                         class="flex--no-wrap"
                    >
                        <div class="pallet-unit__pallet-carton">
                            <table class="table">
                                <thead>
                                    <tr class="table__header-row">
                                        <th class="table__header-cell">
                                            {{ $t('businessOrders.labels.pallet.cartonDimensions') }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table__body-row">
                                        <td class="table__body-cell">
                                            {{ palletPackage.dimensions | valueOrDash }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="pallet-unit__pallet-carton-skus">
                            <order-package-items
                                :package-items="palletPackage.items"
                                :stick-to-sides="false"
                                :business-order="businessOrder"
                                :sku-prefix="skuIndex.toString()"
                            />
                        </div>
                    </div>
                    <h2 v-if="pallet.packages
                            && pallet.packages.some(x => x.palletizationType == 2 || x.palletizationType == null && x.dimensions == zeroDims)"
                        class="heading-with-separator pallet-section-header"
                    >
                        <span class="heading-with-separator__inner">
                            {{ $t('businessOrders.labels.pallet.items') }}
                        </span>
                    </h2>
                    <div v-if="pallet.packages
                             && pallet.packages.some(x => x.palletizationType == 2 || x.palletizationType == null && x.dimensions == zeroDims)"
                         class="flex--no-wrap"
                    >
                        <div class="pallet-unit__pallet-skus">
                            <order-package-items
                                :package-items="pallet.packages.find(x => x.palletizationType == 2
                                    || x.palletizationType == null && x.dimensions == zeroDims).items"
                                :stick-to-sides="false"
                                :business-order="businessOrder"
                                sku-prefix="withItems_"
                            />
                        </div>
                    </div>
                </collapsible-block>
            </div>
        </template>
    </div>
</template>

<script>
import CollapsibleBlock from '@/components/layout/CollapsibleBlock';
import { ValueWrapper } from '@/components/form';
import OrderPackageItems from './OrderPackageItems';

export default {
    components: {
        CollapsibleBlock,
        ValueWrapper,
        OrderPackageItems,
    },
    props: {
        businessOrder: {
            type: Object,
            default: () => ({}),
        },
        isVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            zeroDims: '0" x 0" x 0"',
        };
    },
    computed: {
        packagesWithDimensions() {
            return this.businessOrder.packages.map(orderPackage => ({
                ...orderPackage,
                length: orderPackage.dimensions && orderPackage.dimensions.split('x')[0],
                width: orderPackage.dimensions && orderPackage.dimensions.split('x')[1],
                height: orderPackage.dimensions && orderPackage.dimensions.split('x')[2],
            }));
        },
        palletsWithDimensions() {
            return this.businessOrder.pallets.map(pallet => ({
                ...pallet,
                dimensions: `${pallet.length}" x ${pallet.width}" x ${pallet.height}"`,
            }));
        },
        isLotTrackedOrder() {
            return this.businessOrder.isLotTrackedOrder;
        },
    },
};
</script>

<style lang="scss" scoped>
.handling-units {
    &__heading-subsection {
        display: inline-block;
        padding: 8px 0;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.4;
        text-transform: uppercase;
    }

    &__vertical-separator {
        position: relative;
        top: 20%;
        width: 1px;
        height: 70%;
        background: $color-gray-800;
    }

    &__measurements {
        flex: unset;
        padding-right: 15px;
    }

    &__sku-table {
        margin-top: 20px;
    }
}

.pallet-unit {
    ::v-deep .collapsible-title {
        color: $color-text-bright;
    }

    .pallet-section-header {
        margin-top: 20px;
        margin-bottom: 0;

        .heading-with-separator__inner {
            font-size: 15px;
        }
    }

    &__pallet-carton {
        margin-top: 5px;

        table {
            margin-bottom: 0;

            th,
            td {
                padding-left: 10px;
            }
        }
    }

    &__pallet-carton-skus {
        ::v-deep .table {
            &__header-cell:first-child,
            &__body-cell:first-child {
                padding-left: 50px;
            }
        }
    }

    &__pallet-skus {
        ::v-deep .table {
            &__header-cell:first-child,
            &__body-cell:first-child {
                padding-left: 2px;
            }
        }
    }
}
</style>
